export function authErrorCodeToMessage(errCode) {
    const errorCodes = {
        'auth/email-already-in-use': "このメールアドレスは既に登録されています。",
        'auth/invalid-email': "メールアドレスの形式が無効です。",
        'auth/operation-not-allowed': "このアカウントは無効になってます。",
        'auth/weak-password': "パスワードが脆弱です。",
    }
    return errorCodes[errCode]
}
export function siginInErrorCodeToMessage(code) {
    const errorCodes = {
        'auth/invalid-email': "メールアドレスの形式が無効です。",
        'auth/user-disabled': "無効なユーザーです。",
        'auth/user-not-found': "登録されてません。",
        'auth/wrong-password': "パスワードが正しくありません。",
    }
    return errorCodes[code]
}